import Icon from '@components/utils/icons/icon';
import { SEARCH } from '@constants';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
import { ChangeEventHandler, useEffect, useRef, useState } from 'react';
import { SearchBoxProvided } from 'react-instantsearch-core';
import { connectSearchBox } from 'react-instantsearch-dom';

import { Background, StyledInput } from './commonSearchComponents';

interface Props extends SearchBoxProvided {
    searchQuery?: string | string[];
}

const InputAndCloseContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: ${(props) => props.theme.spacing.xxs};
`;

const CustomSearchBox = ({ searchQuery, refine }: Props) => {
    const theme = useTheme();
    const { t } = useTranslation(SEARCH);
    const [inputValue, setInputValue] = useState<string | string[]>(
        searchQuery ?? ''
    );
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (inputValue) refine(inputValue);
    }, [inputValue, refine]);

    const handleInputChange: ChangeEventHandler<HTMLInputElement> = (e) => {
        refine(e.currentTarget.value);
        setInputValue(e.currentTarget.value);
    };

    const clearInput = () => {
        refine('');
        setInputValue('');
        inputRef.current?.focus();
    };

    return (
        <Background className='search-bar'>
            <Icon
                name='search'
                size='medium'
                color={theme.palette.text.primary}
            />
            <InputAndCloseContainer>
                <StyledInput
                    autoFocus
                    ref={inputRef}
                    id='algolia_search'
                    type='search'
                    placeholder={t('search_home_placeholder')}
                    value={inputValue}
                    onChange={handleInputChange}
                />
                {inputValue.length > 0 && (
                    <Icon name='close' size='medium' onClick={clearInput} />
                )}
            </InputAndCloseContainer>
        </Background>
    );
};

const SearchBarLogic = connectSearchBox<Props>(CustomSearchBox);

export default SearchBarLogic;
